import * as React from "react"
import { IStep } from "./StepGuideComponent"
import Card from "../DataDisplay/CardComponent"

interface IStepGuideContentComponentProps {
    steps: IStep[],
    currentStepNumber: number
}

export default class StepGuideComponent extends React.Component<IStepGuideContentComponentProps> {

    constructor(props: IStepGuideContentComponentProps) {
        super(props)
    }
    public render(): JSX.Element {
        const {
            steps,
            currentStepNumber,
        } = this.props

        return (
            <div>
                {steps && steps
                    .filter((step) => step.id === currentStepNumber)
                    .map((step) =>
                        <Card key={step.id} title={step.title}>
                            {step.longDescription && <div className="row-fluid">
                                {step.longDescription}
                            </div>}
                            {step.content}
                        </Card>
                    )
                }
            </div>
        )
    }
}